/**
 * Clear every sessionStorage key the payments domain writes. Safe to call any
 * time the active user identity changes (logout, account switch).
 *
 * Without this, User B logging in after User A on the same browser inherits
 * A's pending purchase state — User B can resume the funnel and complete a
 * payment that A initiated on A's payment method but tied to B's identity.
 *
 * Keep this list in sync with every `sessionStorage.setItem` call in the
 * payments tree. New pending stores must add their key here.
 */
const PENDING_PAYMENT_STORAGE_KEYS = [
  "pendingGuestStripeSubscriptionSetup",
  "pendingStripePaymentCompletion",
  "pendingStripeDonationConfirmation",
  "pendingReleasePaymentSetup",
  "pendingBundlePaymentSetup",
  "pendingStripeReturnSlideInMenu",
] as const;

export function clearAllPendingPaymentState(): void {
  if (typeof window === "undefined") {
    return;
  }
  for (const key of PENDING_PAYMENT_STORAGE_KEYS) {
    window.sessionStorage.removeItem(key);
  }
}
